const STATUS = {
  UNAUTHORIZED: 404,
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500,
};

export default STATUS;
